import React, { PureComponent, useContext, useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import styles from "./Navigation.module.css";
import { NavLink } from "react-router-dom";
import { routes } from "../../constants/consts-routes";
import { LIB } from "../../constants/consts-lib";
import { defaultQuery } from "../../constants/const-param-keys";
import { resetPageIndex } from "../../services/service-url-search-params";
import { setLockedViewport } from "../../services/service-utils";
import { StateContext } from "../../StateContext";

const MyList = ({ className, onClick }) => {
  const { myList } = useContext(StateContext);
  const length = myList && myList.length ? myList.length : 0;

  const [initialized, setInitialized] = useState(false);
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    if (!initialized) {
      setInitialized(true);
    }
  }, [initialized]);

  useEffect(() => {
    if (initialized) {
      setAnimate(true);
    }
  }, [length]);

  return (
    <NavLink
      key={length}
      to={routes.my_list.pathname}
      onClick={onClick}
      className={`${className} ${animate ? styles.myList : ""}`}
    >
      {LIB.PAGE_TITLES.my_list}
      <span>{` (${length})`}</span>
    </NavLink>
  );
};

class Navigation extends PureComponent {
  onLinkClick = () => {
    window.scrollTo(0, 0);
    if (this.props.onItemClick) {
      this.props.onItemClick();
    }
  };

  onNavClick = () => setLockedViewport(false);

  testActivePath = test =>
    typeof test === "function"
      ? test(window.location.pathname)
      : test === window.location.pathname;

  isActive = test =>
    Array.isArray(test)
      ? test.some(this.testActivePath)
      : this.testActivePath(test);

  isActiveClass = test =>
    this.isActive(test) ? styles.linkActive : styles.link;

  render() {
    const { location, onNavClick, className } = this.props;

    const search = resetPageIndex(location.search);

    const aboutUrl = window.location.pathname.startsWith("/en")
      ? "https://www.smk.dk/en/about-smk-open/"
      : "https://www.smk.dk/om-smk-open/";

    return (
      <ul className={[styles.list, className].join(" ")}>
        <li>
          <NavLink
            to={routes.search.pathname + (search ? search : defaultQuery)}
            onClick={this.onLinkClick}
            className={this.isActiveClass([
              routes.search.pathname,
              path => path.startsWith(routes.filter_by_advanced.pathname)
            ])}
          >
            {LIB.PAGE_TITLES.search}
          </NavLink>
        </li>
        <li>
          <NavLink
            to={routes.themes.pathname}
            onClick={this.onLinkClick}
            className={this.isActiveClass(routes.themes.pathname)}
          >
            {LIB.PAGE_TITLES.themes}
          </NavLink>
        </li>
        <li>
          <MyList
            className={this.isActiveClass(routes.my_list.pathname)}
            onClick={onNavClick}
          />
        </li>
        <li>
          <a
            href={aboutUrl}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.link}
          >
            {LIB.PAGE_TITLES.about}
          </a>
        </li>
      </ul>
    );
  }
}

export default withRouter(Navigation);
